export const button = {
  save: 'Simpan',
  add: 'Tambah',
  yes: 'Ya',
  no: 'Tidak',
  update: 'Perbarui',
  change: 'Ganti',
  cancel: 'Membatalkan',
  confirm: 'Konfirmasi',
  upload: 'unggah File',
  import: 'Impor file',
  back: 'Kembali',
  request: 'Meminta',
  next: 'Berikutnya',
  download: 'Unduh',
  ok: 'OK'
};
